<vex-table *ngIf="params"
  [params] = "params"
  (updatedSettledAmount)="getIsUpdatedValue($event)">
</vex-table>
